import React from "react";
import { Modal, Box, Typography, IconButton } from "@mui/material";
import { Form, Button, Alert } from "react-bootstrap";
import CloseIcon from "@mui/icons-material/Close";
import styled from "styled-components";
import "../styles/PdfPreviewModal.css";
import SaveIcon from "@mui/icons-material/Save";
import DownloadIcon from "@mui/icons-material/Download";

const Legend = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  background: transparent;
  padding: 10px;
`;

const LegendItem = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  color: #64748b;
  span {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 2px;
    margin-right: 8px;
    background-color: ${({ color }) => color};
  }
`;


const PdfPreviewModal = ({
  isModalOpen,
  handleClose,
  pdfImageSrc,
  selectedTemplate,
  handleDownloadPdf,
  error,
  successMessage,
  templateName,
  setTemplateName,
  handleTemplateSave,
  isDesktop
}) => {
  const [showSaveForm, setShowSaveForm] = React.useState(false);

  return (
    <Modal
      open={isModalOpen}
      aria-labelledby="pdf-preview-modal"
      aria-describedby="pdf-preview-description"
      onClose={handleClose}
      hideBackdrop={isDesktop}
      disableEnforceFocus={isDesktop}
      disablePortal={isDesktop}
      disableScrollLock={isDesktop}
      className={isDesktop ? "modal-root-desktop" : ""}
    >
      <Box
        className={isDesktop ? "modal-container-desktop" : "modal-container-mobile"}
        sx={{ p: { xs: 2, sm: 3, md: 4 } }}
      >
        <IconButton
          onClick={handleClose}
          className="close-button"
          sx={{
            transition: 'all 0.2s',
            p: { xs: 0.5, sm: 1 }
          }}
        >
          <CloseIcon sx={{ fontSize: { xs: 12, sm: 16 } }} />
        </IconButton>
        <div className="modal-header-section" style={{ marginBottom: isDesktop ? '16px' : '12px' }}>
          <Typography
            id="pdf-preview-modal"
            variant="subtitle1"
            sx={{
              fontWeight: 800,
              color: '#1e293b',
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              fontSize: { xs: '0.75rem', sm: '1.1rem' }
            }}
          >
            {selectedTemplate}
          </Typography>
        </div>


        <div className="modal-top-content-section" >
          <div className="modal-top-legends">
            <Legend style={{ padding: '0', gap: '15px' }}>
              <LegendItem color="#9400d3" style={{ fontSize: '12px', fontWeight: 600 }}><span></span>Variable</LegendItem>
              <LegendItem color="brown" style={{ fontSize: '12px', fontWeight: 600 }}><span></span>Fixed</LegendItem>
            </Legend>
          </div>

          {!showSaveForm ? (
            <div className="action-buttons">
              <Button
                className="primary-button"
                style={{ gap: '3px' }}
                onClick={() => setShowSaveForm(true)}
              >
                <SaveIcon sx={{ fontSize: 16 }} />
                <span className="preview-btn-text">Save</span>
              </Button>
              <Button
                onClick={handleDownloadPdf}
                className="primary-button"
                style={{ gap: '2px' }}
              >
                <DownloadIcon sx={{ fontSize: 16 }} />
                <span className="preview-btn-text">Download</span>
              </Button>
            </div>
          ) : (
            <div className="save-form-container">
              <div className="save-form-row">
                <Form.Group controlId="templateName" style={{ flex: 1, marginBottom: 0 }}>
                  <Form.Control
                    type="text"
                    value={templateName}
                    onChange={(e) => setTemplateName(e.target.value)}
                    placeholder="Template Name"
                    className="template-input"
                  />
                </Form.Group>
                <div className="save-form-actions">
                  <Button
                    variant="danger"
                    onClick={() => setShowSaveForm(false)}
                    className="cancel-button"
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={handleTemplateSave}
                    className="confirm-button"
                  >
                    Confirm
                  </Button>
                </div>
              </div>
            </div>
          )}
        </div>

        {error && (
          <Alert variant="danger" className="alert-error">
            {error}
          </Alert>
        )}

        {successMessage && (
          <Alert variant="success" className="alert-success">
            {successMessage}
          </Alert>
        )}

        <div className="pdf-display-frame" >
          {pdfImageSrc ? (
            <img
              src={pdfImageSrc}
              className="pdf-image"
              alt="PDF preview"
            />
          ) : (
            <div className="loading-container">
              <Typography className="loading-text">Loading preview...</Typography>
            </div>
          )}
        </div>
      </Box>
    </Modal>
  );
};

export default PdfPreviewModal;
